import { Menu, Transition } from "@headlessui/react";
import { Fragment, useEffect, useRef, useState } from "react";
import { DotsVerticalIcon } from "@heroicons/react/solid";

export default function DropDown(props) {
  return (
    <Menu as="div" className="relative justify-center self-center text-left">
      <Menu.Button className="flex hover:cursor-pointer my-auto mr-2">
        {props.menuButton ? (
          props.menuButton
        ) : (
          <DotsVerticalIcon className="h-6" aria-hidden="true" />
        )}
      </Menu.Button>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute z-20 right-0 mt-2 origin-top-right bg-white divide-y divide-gray-100 rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
          {props.items?.map((item) => (
            <Menu.Item>
              <button
                className="w-full whitespace-pre py-1 px-4 hover:bg-gray-200"
                onClick={() => props._handleSelected(item)}
              >
                {item}
              </button>
            </Menu.Item>
          ))}
        </Menu.Items>
      </Transition>
    </Menu>
  );
}
